var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7595 9.6688L10.7183 17.7101C9.73316 18.6952 8.39706 19.2486 7.0039 19.2486C5.61074 19.2486 4.27463 18.6952 3.28952 17.7101C2.30441 16.7249 1.75098 15.3888 1.75098 13.9957C1.75098 12.6025 2.30441 11.2664 3.28952 10.2813L11.3308 2.24005C11.9875 1.58331 12.8782 1.21436 13.807 1.21436C14.7358 1.21436 15.6265 1.58331 16.2833 2.24005C16.94 2.89679 17.309 3.78753 17.309 4.7163C17.309 5.64508 16.94 6.53581 16.2833 7.19255L8.23327 15.2338C7.9049 15.5622 7.45953 15.7467 6.99515 15.7467C6.53076 15.7467 6.08539 15.5622 5.75702 15.2338C5.42865 14.9054 5.24417 14.4601 5.24417 13.9957C5.24417 13.5313 5.42865 13.0859 5.75702 12.7576L13.1858 5.33755",
    stroke: "#667085",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/file-upload.cd1113a495a274f95df6fe1b1c14d34b.svg";
export { ForwardRef as ReactComponent };